module.exports = __webpack_public_path__ + "static/media/subICloud1.3e86cea4.png";